import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-auto-logout',
  templateUrl: './auto-logout.component.html',
  styleUrls: ['./auto-logout.component.scss']
})
export class AutoLogoutComponent implements OnInit, OnDestroy {

  timeLeft = 60;
  progressBarValue = 100;
  interval;
  dialogClosed = false;

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.progressBarValue = (this.timeLeft / 60) * 100;
      }
      if (this.timeLeft === 0) {
        if (!this.dialogClosed) {
            this.logout();
        }
      }
    }, 1000);
  }

  constructor( private dialogRef: MatDialogRef<AutoLogoutComponent>) { }

  ngOnInit(): void {

    this.startTimer();
  }

  ngOnDestroy() {
    this.dialogClosed = true;
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  close() {
    this.dialogClosed = true;
    clearInterval(this.interval);
    this.dialogRef.close({logout: false});
  }

  logout() {
    this.dialogClosed = true;
    clearInterval(this.interval);
    this.dialogRef.close({logout: true});
  }
}
